import React, {useState} from 'react';
import StudentModalForm from '../Modals/StudentModalForm';

import { IconButton, Tooltip } from '@material-ui/core';
import { AddBox as AddBoxIcon } from '@material-ui/icons';

const Toolbar = (props) => {

    const [open, setOpen] = useState(false);
    // const [selectedStudent, setSelectedStudent] = useState(null);

    const handleClick = () => {
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    }

    return (
        <>
            <IconButton aria-label="create" onClick={handleClick}>
                <Tooltip title="Create">
                    <AddBoxIcon />
                </Tooltip>
            </IconButton>

            <StudentModalForm
                dialogTitle={'New Student'}
                open={open}
                handleClose={handleClose}
                fetchStudents={props.fetchStudents}
                selectedStudent={null}
            />
        </>
    );
}

export default Toolbar;